export const translations = {
    vn: {
        title: 'THÔNG BÁO MỜI HỌP VÀ TÀI LIỆU HỌP\nĐẠI HỘI ĐỒNG CỔ ĐÔNG THƯỜNG NIÊN NĂM 2026',

        greeting_left: 'Kính gửi:',
        greeting_right: 'Quý Cổ đông CTCP Tập đoàn Bệnh viện TNH',

        intro: 'Hội đồng quản trị Công ty Cổ phần Tập đoàn Bệnh viện TNH trân trọng mời cổ đông tham dự cuộc họp Đại hội đồng cổ đông thường niên năm 2026 với các nội dung như sau:',

        sections: [
            '1. Thời gian tổ chức Đại hội: bắt đầu lúc 8h30ph ngày 15/05/2026.',
            '2. Phương thức tổ chức Đại hội: Họp bằng phương thức trực tuyến kết hợp trực tiếp và bỏ phiếu điện tử.',
            '3. Địa điểm tổ chức Đại hội: Bệnh viện TNH Lạng Sơn (Khối 10, đường Nhị Thanh, phường Tam Thanh, tỉnh Lạng Sơn)',
        ],

        section4_title: '4. Điều kiện và cách thức tham dự họp Đại hội:',

        a: 'a. Điều kiện tham dự:',
        a_content:
            'Tất cả cổ đông sở hữu cổ phần của Công ty Cổ phần Tập đoàn Bệnh viện TNH  có tên trong danh sách cổ đông chốt ngày 14/04/2026 do Tổng Công ty lưu ký và Bù trừ chứng khoán Việt Nam cung cấp.',

        b: 'b. Cách thức tham dự:',
        b_content: [
            'Tham dự trực tuyến: Quý cổ đông sử dụng một trong các thiết bị: máy tính bàn/máy tính xách tay/máy tính bảng/điện thoại thông minh có kết nối Internet để tham dự Đại hội trực tuyến. Cổ đông đăng nhập vào hệ thống, tiến hành đăng ký tham dự kể từ thời điểm nhận được thư mời và thực hiện biểu quyết sau khi cổng biểu quyết được mở. Tham dự trực tiếp: Khi đến dự họp, cổ đông mang theo Thư mời họp và Chứng minh nhân dân/Căn cước công dân/Hộ chiếu còn thời hạn sử dụng. Trường hợp Cổ đông là tổ chức thì người đại diện Cổ đông dự họp phải xuất trình giấy tờ chứng minh tư cách đại diện hợp lệ.',
            'Tham dự theo ủy quyền: Khi đến dự họp, người được ủy quyền của cổ đông mang theo Thư mời họp; Giấy ủy quyền hợp lệ theo mẫu (Bản gốc); và Chứng minh nhân dân/Căn cước công dân/Hộ chiếu còn thời hạn sử dụng của người được ủy quyền.',
        ],

        note: ['Ghi chú:', ' Người được ủy quyền không được ủy quyền lại cho người khác.'],

        voting: 'Đại hội thực hiện hình thức biểu quyết duy nhất là bỏ phiếu điện tử trên Hệ thống tại website:',

        website: 'https://tnh.ezgsm.fpts.com.vn/',

        section5_title: '5. Đăng ký tham dự và biểu quyết:',
        section5_content: [
            ' Quý cổ đông vui lòng truy cập website',
            ' và đăng nhập theo tên đăng nhập và mật khẩu được gửi trong Thư mời để đăng ký tham dự và biểu quyết – bầu cử tại Đại hội. Thông tin đăng nhập hệ thống đã được gửi qua Thư mời và qua Email tới các cổ đông của Công ty.',
        ],

        section6_title: '5. Chương trình họp và các tài liệu cuộc họp:',
        agenda: [
            {
                no: '1.',
                text: 'Công bố thông tin về việc ban hành Nghị quyết của HĐQT số 115/2026/NQ-TNH ngày 23/04/2026 về việc thông qua thời thời gian, địa điểm, nội dung chương trình họp Đại hội đồng thường niên năm 2026 và tài liệu cuộc họp.',
                link: '/file/1-cbtt-nq-thong-qua-to-chuc-hop.pdf',
            },
            {
                no: '2.',
                text: 'Nghị quyết của HĐQT số 115/2026/NQ-TNH ngày 23/04/2026 về việc thông qua thời thời gian, địa điểm, nội dung chương trình họp Đại hội đồng thường niên năm 2026 và tài liệu cuộc họp.',
                link: '/file/2-nghi-quyet-thong-qua-tai-lieu-hop-h-c-2026-1.pdf',
            },
            {
                no: '3.',
                text: 'Thông báo mời họp ĐHĐCĐ thường niên năm 2026.',
                link: '/file/3-tb-moi-hop-hdc-2026.pdf',
            },
            {
                no: '4.',
                text: 'Chương trình họp ĐHĐCĐ thường niên năm 2026.',
                link: '/file/4-chuong-trinh-hop-h.pdf',
            },
            {
                no: '5.',
                text: 'Thông báo về việc đề cử, ứng cử Thành viên HĐQT nhiệm kỳ 2025-2030.',
                link: '/file/5-tb-e-cu-ung-cu-tv-h-qt-a-ky.pdf',
            },
            {
                no: '6.',
                text: 'Giấy ủy quyền tham dự ĐHĐCĐ thường niên năm 2026.',
                link: '/file/6-giay-uy-quyen.pdf',
            },
            {
                no: '7.',
                text: 'Mẫu phiếu biểu quyết.',
                link: '/file/7-mau-phieu-bieu-quyet.pdf',
            },
            {
                no: '8.',
                text: 'Quy chế tổ chức Đại hội.',
                link: '/file/8-quy-che-to-chuc-ai-hoi.pdf',
            },
            {
                no: '9.',
                text: 'Tờ trình thông qua Ban Chủ tọa, Ban kiểm phiếu.',
                link: '/file/9-to-trinh-thong-qua-ban-chu-toa-ban-kiem-phieu.pdf',
            },
            {
                no: '10.',
                text: 'Thảo luận và thông qua Báo cáo tài chính riêng và Báo cáo tài chính hợp nhất đã được kiểm toán năm 2025 của Công ty cổ phần Tập đoàn Bệnh viện TNH.',
                link: '/file/10-to-trinh-thong-qua-bao-cao-tai-chinh-2025.pdf',
            },
            {
                no: '11.',
                text: 'Thảo luận và thông qua việc lựa chọn đơn vị kiểm toán BCTC năm 2026 của Công ty cổ phần Tập đoàn Bệnh viện TNH.',
                link: '/file/11-ttr-thong-qua-viec-lua-chon-on-vi-kiem-toan-bctc-2026.pdf',
            },
            {
                no: '12.',
                text: 'Thảo luận và thông qua Báo cáo kết quả kinh doanh năm 2025 và Kế hoạch kinh doanh năm 2026 của Công ty.',
                link: '/file/12-ttr-bao-cao-ket-qua-h-sxkd-2025.pdf',
            },
            {
                no: '13.',
                text: 'Thảo luận và thông qua Báo cáo của Hội đồng quản trị về kết quả hoạt động năm 2025 và phương hướng hoạt động năm 2026.',
                link: '/file/13-bc-cua-h-qt-ve-kqhd-2025-kh-2026.pdf',
            },
            {
                no: '14.',
                text: 'Thảo luận và thông qua Báo cáo đánh giá hoạt động của thành viên độc lập Hội đồng quản trị.',
                link: '/file/14-ttr-bao-cao-thanh-vien-oc-lap.pdf',
            },
            {
                no: '15.',
                text: 'Báo cáo của Thành viên HĐQT độc lập Nguyễn Thị Thùy Giang.',
                link: '/file/15-bao-cao-thanh-vien-oc-lap-nttg.pdf',
            },
            {
                no: '16.',
                text: 'Báo cáo của Thành viên HĐQT độc lập Romeo Fernandez Lledo.',
                link: '/file/16-bao-cao-thanh-vien-oc-lap-romeo.pdf',
            },
            {
                no: '17.',
                text: 'Thảo luận và thông qua Báo cáo hoạt động năm 2025 của Ủy ban kiểm toán năm 2025.',
                link: '/file/17-ttr-bao-cao-hoat-ong-nam-2025-ubkt.pdf',
            },
            {
                no: '18.',
                text: 'Báo cáo hoạt động của Ủy ban kiểm toán.',
                link: '/file/18-bao-cao-cua-uy-ban-kiem-toan-kem-ttr-108.pdf',
            },
            {
                no: '19.',
                text: 'Thảo luận và thông qua mức thù lao cho thành viên Hội đồng quản trị và Ban kiểm soát năm 2025.',
                link: '/file/19-ttr-thong-qua-muc-thu-lao.pdf',
            },
            {
                no: '20.',
                text: 'Thảo luận và thông qua việc thay đổi số lượng người đại diện theo pháp luật và thay đổi cơ cấu bộ máy Ban điều hành.',
                link: '/file/20-ttr-thay-oi-so-luong-nguoi-ai-dien-va-co-cau-bo-may-b-h.pdf',
            },
            {
                no: '21.',
                text: 'Thảo luận và thông qua việc miễn nhiệm và bầu bổ sung 01 thành viên HĐQT nhiệm kỳ 2025-2030.',
                link: '/file/21-to-trinh-mien-nhiem-va-bo-sung-01-thanh-vien-h-qt.pdf',
            },
            {
                no: '22.',
                text: 'Thảo luận và thông qua việc sửa đổi Điều lệ tổ chức và hoạt động, Quy chế nội bộ về quản trị công ty và Quy chế hoạt động của HĐQT.',
                link: '/file/22-ttr-sua-oi-ieu-le-quy-che.pdf',
            },
            {
                no: '23.',
                text: 'Dự thảo Điều lệ Công ty Cổ phần Tập đoàn Bệnh viện TNH.',
                link: '/file/23-dieu-le-cong-ty-2026.pdf',
            },
            {
                no: '24.',
                text: 'Bảng so sánh nội dung sửa đổi, bổ sung Điều lệ.',
                link: '/file/24-phu-luc-so-sanh-dieu-le-2026.pdf',
            },
            {
                no: '25.',
                text: 'Dự thảo Quy chế hoạt động của HĐQT.',
                link: '/file/25-quy-che-hoat-dong-h-qt.pdf',
            },
            {
                no: '26.',
                text: 'Bảng so sánh nội dung sửa đổi, bổ sung Quy chế hoạt động của HĐQT.',
                link: '/file/26-phu-luc-so-sanh-quy-che-h-qt.pdf',
            },
            {
                no: '27.',
                text: 'Dự thảo Quy chế nội bộ về quản trị Công ty',
                link: '/file/27-quy-che-noi-bo-ve-quan-tri-cong-ty.pdf',
            },
            {
                no: '28.',
                text: 'Bảng so sánh nội dung sửa đổi, bổ sung Quy chế nội bộ về quản trị Công ty',
                link: '/file/28-phu-luc-ss-quy-che-noi-bo-qt.pdf',
            },
            {
                no: '29.',
                text: 'Dự thảo Nghị quyết ĐHĐCĐ thường niên năm 2026.',
                link: '/file/29-du-thao-nghi-quyet.pdf',
            },
            {
                no: '30.',
                text: 'Các vấn đề khác thuộc thẩm quyền của Đại hội đồng cổ đông (nếu có).',
                link: '/file/khac.pdf',
            },
        ],

        support_title: '6. Liên hệ hỗ trợ:',
        support_content:
            'Mọi vấn đề phát sinh, thắc mắc liên quan hoặc có ý kiến kiến nghị vấn đề đưa vào chương trình họp (kiến nghị gửi bằng văn bản) vui lòng liên hệ/gửi thư đến địa chỉ sau trước 16h00 ngày 12/05/2026: Ms. Hứa Thị Hoa Linh (SĐT: 0947 633 282).',
        footer: 'Địa chỉ: Số nhà 328, Đường Lương Ngọc Quyến, Phường Phan Đình Phùng, Tỉnh Thái Nguyên, Việt Nam.\nĐiện thoại: 0888 143 115 | Email: ir.tnh@tnh.com.vn\nTrân trọng./.',
    },
    en: {
        title: 'MEETING NOTICE AND DOCUMENTS OF \nANNUAL GENERAL MEETING OF SHAREHOLDERS 2026',

        greeting_left: 'To:',
        greeting_right: 'Shareholders of TNH Hospital Group Joint Stock Company',

        intro: 'The Board of Directors of TNH Hospital Group Joint Stock Company respectfully invites shareholders to attend the Annual General Meeting of Shareholders 2026 with the following agenda: ',

        sections: [
            '1. Time of the Meeting: starting at 8:30 AM on May 15, 2026 .',
            '2. Method of organizing the Meeting: The meeting will be conducted using a combination of online and in-person methods, along with electronic voting.',
            '3. Venue: TNH Lang Son Hospital (Block 10, Nhi Thanh Street, Tam Thanh Ward, Lang Son Province)',
        ],

        section4_title: '4. Conditions and procedures for attending the Meeting:',

        a: 'a. Eligibility requirements:',
        a_content:
            'All shareholders owning shares of TNH Hospital Group Joint Stock Company whose names are on the shareholder list as of April 14, 2026, provided by the Vietnam Securities Depository and Clearing Corporation.',

        b: 'b. How to participate:',
        b_content: [
            'Online participation: Shareholders can use one of the following devices: desktop computer/laptop/tablet/smartphone with internet connection to participate in the online General Meeting. Shareholders log into the system, register to attend from the time they receive the invitation letter, and vote after the voting portal opens. In-person participation: When attending the meeting, shareholders must bring the meeting invitation letter and a valid National Identity Card/Citizen ID Card/Passport. In the case of a shareholder organization, the shareholder representative must present documents proving their valid representative status.',
            "Attending by proxy: When attending the meeting, the shareholder's authorized representative must bring the Meeting Invitation Letter; a valid Power of Attorney form (original); and the authorized representative's valid National Identity Card/Citizen ID Card/Passport.",
        ],

        note: ['Note:', ' The authorized person may not re-authorize another person.'],

        voting: 'The General Meeting will use only one voting method: electronic voting via the System at the website:',

        website: 'https://tnh.ezgsm.fpts.com.vn/',

        section5_title: '5. Registration and Voting:',
        section5_content: [
            ' Shareholders are kindly requested to access the website',
            ' and log in using the username and password sent in the Invitation Letter to register for attendance and voting at the General Meeting. System login information has been sent via the Invitation Letter and email to all shareholders of the Company.',
        ],

        section6_title: '5. Meeting agenda and meeting documents:',
        agenda: [
            {
                no: '1.',
                text: 'Disclosure of information regarding the issuance of the Board of Directors’ Resolution No. 115/2026/NQ-TNH dated April 23, 2026 on approving the time, venue, agenda of the 2026 Annual General Meeting of Shareholders and the meeting materials.',
                link: '/file/1-cbtt-nq-thong-qua-to-chuc-hop.pdf',
            },
            {
                no: '2.',
                text: 'Board of Directors’ Resolution No. 115/2026/NQ-TNH dated April 23, 2026 on approving the time, venue, agenda of the 2026 Annual General Meeting of Shareholders and the meeting materials.',
                link: '/file/2-nghi-quyet-thong-qua-tai-lieu-hop-h-c-2026-1.pdf',
            },
            {
                no: '3.',
                text: 'Notice of invitation to the 2026 Annual General Meeting of Shareholders.',
                link: '/file/3-e-thong-bao-moi-hop.pdf',
            },
            {
                no: '4.',
                text: 'Agenda of the 2026 Annual General Meeting of Shareholders.',
                link: '/file/4-e-chuong-trinh-h.pdf',
            },
            {
                no: '5.',
                text: 'Notice regarding nomination and self-nomination for members of the Board of Directors for the 2025–2030 term.',
                link: '/file/5-e-thong-bao-de-cu-ung-cu-da-ky.pdf',
            },
            {
                no: '6.',
                text: 'Power of Attorney for attendance at the 2026 Annual General Meeting of Shareholders.',
                link: '/file/6-e-giay-uy-quyen.pdf',
            },
            {
                no: '7.',
                text: 'Voting ballot template.',
                link: '/file/7-e-mau-phieu-bieu-quyet.pdf',
            },
            {
                no: '8.',
                text: 'Regulations on the organization of the General Meeting.',
                link: '/file/8-e-quy-che-to-chuc-dai-hoi.pdf',
            },
            {
                no: '9.',
                text: 'Proposal for approval of the Presidium and the Vote Counting Committee.',
                link: '/file/9-e-102-to-trinh-thong-qua-ban-chu-toa-bkp.pdf',
            },
            {
                no: '10.',
                text: 'Discussion and approval of the Company’s audited separate and consolidated financial statements for 2025.',
                link: '/file/10-e-103-ttr-thong-qua-bctc.pdf',
            },
            {
                no: '11.',
                text: 'Discussion and approval of the selection of the audit firm for the Company’s 2026 financial statements.',
                link: '/file/11-e-104-ttr-thong-qua-don-vi-kiem-toan-bctc.pdf',
            },
            {
                no: '12.',
                text: 'Discussion and approval of the Company’s 2025 business performance report and the 2026 business plan.',
                link: '/file/12-e-105-ttr-thong-qua-bc-kq-kd-2025-kh-2026.pdf',
            },
            {
                no: '13.',
                text: 'Discussion and approval of the Board of Directors’ report on performance results in 2025 and orientations for 2026.',
                link: '/file/13-e-106-ttr-bc-h-qt-2025.pdf',
            },
            {
                no: '14.',
                text: 'Discussion and approval of the report on the performance evaluation of Independent Members of the Board of Directors.',
                link: '/file/14-e-107-ttr-bao-cao-thanh-vien-doc-lap.pdf',
            },
            {
                no: '15.',
                text: 'Report of Independent Board Member Ms. Nguyen Thi Thuy Giang.',
                link: '/file/15-e-bao-cao-thanh-vien-doc-lap-nttg-kem-theo-tt-107.pdf',
            },
            {
                no: '16.',
                text: 'Report of Independent Board Member Mr. Romeo Fernandez Lledo.',
                link: '/file/16-e-bao-cao-thanh-vien-doc-lap-romeo-kem-theo-ttr-107.pdf',
            },
            {
                no: '17.',
                text: 'Discussion and approval of the 2025 operational report of the Audit Committee.',
                link: '/file/17-e-ttr-bao-cao-cua-ubkt.pdf',
            },
            {
                no: '18.',
                text: 'Audit Committee Report.',
                link: '/file/18-e-bao-cao-cua-ubkt-kem-ttr-108.pdf',
            },
            {
                no: '19.',
                text: 'Discussion and approval of remuneration for members of the Board of Directors and the Supervisory Board for 2025.',
                link: '/file/19-e-ttr-109-muc-thu-lao.pdf',
            },
            {
                no: '20.',
                text: 'Discussion and approval of changes to the number of legal representatives and the organizational structure of the Executive Board.',
                link: '/file/20-e-110-ttr-thay-doi-nguoi-so-luong-nguoi-dai-dien-va-co-cau-b-h.pdf',
            },
            {
                no: '21.',
                text: 'Discussion and approval of the dismissal and additional election of one (01) member of the Board of Directors for the 2025–2030 term.',
                link: '/file/21-e-111-ttr-thong-qua-viec-mien-nhiem-va-bau-bo-sung-tv-h-qt.pdf',
            },
            {
                no: '22.',
                text: 'Discussion and approval of amendments to the Charter, the Internal Regulations on Corporate Governance, and the Regulations on the operation of the Board of Directors.',
                link: '/file/22-e-112-ttr-sua-doi-dieu-le-quy-che-cong-ty.pdf',
            },
            {
                no: '23.',
                text: 'Draft Charter of TNH Hospital Group Joint Stock Company.',
                link: '/file/23-e-dieu-le-cong-ty-2026.pdf',
            },
            {
                no: '24.',
                text: 'Comparison table of amendments and supplements to the Charter.',
                link: '/file/24-e-phu-luc-so-sanh-sua-dieu-le-2026.pdf',
            },
            {
                no: '25.',
                text: 'Draft Regulations on the operation of the Board of Directors.',
                link: '/file/25-e-quy-che-hoat-dong-h-qt.pdf',
            },
            {
                no: '26.',
                text: 'Comparison table of amendments and supplements to the Regulations on the operation of the Board of Directors.',
                link: '/file/26-e-phu-luc-so-sanh-quy-che-hoat-dong-h-qt.pdf',
            },
            {
                no: '27.',
                text: 'Draft Internal Regulations on Corporate Governance.',
                link: '/file/27-e-quy-che-noi-bo-ve-qtdn-2026.pdf',
            },
            {
                no: '28.',
                text: 'Comparison table of amendments and supplements to the Internal Regulations on Corporate Governance.',
                link: '/file/28-e-phu-luc-so-snah-sua-quy-che-noi-bo.pdf',
            },
            {
                no: '29.',
                text: 'Draft Resolution of the 2026 Annual General Meeting of Shareholders.',
                link: '/file/29-e-du-thao-nghi-quyet.pdf',
            },
            {
                no: '30.',
                text: 'Other matters within the authority of the General Meeting of Shareholders (if any).',
                link: '/file/29-e-du-thao-nghi-quyet.pdf',
            },
        ],

        support_title: '6. Contact support',
        support_content:
            'For any issues, questions, or suggestions for inclusion in the meeting agenda (please submit in writing), please contact/send a letter to the following address before 4:00 PM, May 12, 2026: Ms. Hua Thi Hoa Linh (Phone number: 0947 633 282).',
        footer: 'Address: 328 Luong Ngoc Quyen Street, Phan Dinh Phung Ward, Thai Nguyen Province, Vietnam.\nPhone: 0888 143 115 	Email: ir.tnh@tnh.com.vn\nBest regards./.',
    },
};
